import type {
  IGridGroup,
  IInventoryTemplateDetail,
  IInventoryTemplateItemGroup,
} from '../models';

const DETAILS_WITH_NO_GROUP = 'Details with no group';

/**
 * Groups inventory template details by their item group, resolving group names
 * from the provided itemGroups list. Falls back to a placeholder name when
 * itemGroups is not yet loaded (undefined/null) or when no match is found,
 * instead of throwing a TypeError.
 */
export function buildGridDetailGroups(
  details: IInventoryTemplateDetail[],
  itemGroups: IInventoryTemplateItemGroup[] | undefined | null
): IGridGroup<IInventoryTemplateDetail>[] {
  const gridDetailGroupsMap = details.reduce<
    Record<string, IInventoryTemplateDetail[]>
  >((map, detail) => {
    const key =
      detail.item?.itemGroupId ||
      detail.item?.itemGroup?.itemGroupId ||
      DETAILS_WITH_NO_GROUP;
    return { ...map, [key]: map[key] ? [...map[key], detail] : [detail] };
  }, {});

  return Object.keys(gridDetailGroupsMap).reduce<
    IGridGroup<IInventoryTemplateDetail>[]
  >((acc, groupKey) => {
    const items = gridDetailGroupsMap[groupKey];
    const groupName =
      itemGroups?.find((g) => g.itemGroupId === groupKey)?.itemGroupName ||
      DETAILS_WITH_NO_GROUP;
    return [
      ...acc,
      {
        field: 'item.itemGroupId',
        items,
        aggregates: items.length,
        value: groupName,
      } as unknown as IGridGroup<IInventoryTemplateDetail>,
    ];
  }, []);
}
